import type { Query, QueryClient } from '@tanstack/react-query'
import type { companyagreementApi } from 'app/src/services/welfareportal'
import { removeQuotes } from 'app/src/shared/helpers'
import { useProductList as useProductListOriginal } from './companyagreement-components'
import type * as Schemas from './companyagreement-schemas'

function invalidateCacheByOperationId(queryClient: QueryClient, ...operationIdsToBeInvalidated: AllQueryOperationsIds[]): void {
  void queryClient.invalidateQueries({
    predicate: (query: Query) => {
      const [queryOperationId] = query.queryKey

      if (typeof queryOperationId === 'string') {
        return operationIdsToBeInvalidated.includes(queryOperationId as AllQueryOperationsIds)
      }

      return false
    },
  })
}

type QueryOperationApiPrefixes = {
  companyagreementApi: 'companyagreement-api.'
}

type AllQueryOperationsIds =
  `${QueryOperationApiPrefixes['companyagreementApi']}${companyagreementApi.QueryOperation['operationId']}`

function getQueryOperationIdWithPrefix(
  prefix: QueryOperationApiPrefixes[keyof QueryOperationApiPrefixes],
  operationId: string,
): string {
  return `${prefix}${operationId}`
}

const useProductList = <TData = Schemas.ProductPaginated>(...args: Parameters<typeof useProductListOriginal<TData>>) => {
  if (args[0].queryParams?.name) args[0].queryParams.name = removeQuotes(args[0].queryParams.name)
  return useProductListOriginal(...args)
}

export { getQueryOperationIdWithPrefix, invalidateCacheByOperationId, useProductList }
